import React from "react";
import "./dadosIniciais.scss";

//Componentes
import Field from "../../../../components/field";
import Form from "../../../../components/form";
import CheckObligation from "../../components/checkObligation";
import FieldTelefone from "../../../../components/fieldTelefone";
import Utils from "../../../../helper/validateUtils";

class DadosIniciais extends React.Component {
  constructor(props) {
    super(props)
    this.props.updateState({ currentValidation: this.handleValidations });
    this.setDadosIniciais = (changes) => {
      this.props.updateState({
        dadosIniciais: { ...this.props.dadosIniciais, ...changes },
      });
    };
    this.changeDadosIniciaisForm = this.changeDadosIniciaisForm.bind(this);
    this.changeDadosIniciais = this.changeDadosIniciais.bind(this);
  }

  componentWillMount() {
    this.formFields = [];

    const {
      configuracaoDdi,
    } = this.props;

    configuracaoDdi();
  }

  changeDadosIniciaisForm(name, value) {
    const form = this.props.dadosIniciais.form;
    this.setDadosIniciais({ form: { ...form, [name]: value } });
  }

  changeDadosIniciais(name, value) {
    this.setDadosIniciais({ [name]: value });
  }

  CheckObligationAssociado = (props) => <CheckObligation {...props} currentStep={this.props.currentStep} />;

  render() {
    const {
      form,
      dadosIniciais_idDDDpais,
    } = this.props.dadosIniciais;

    const { ddiFixoBrasil, listPais } = this.props.ddiReducer;

    const CheckObligationAssociado = this.CheckObligationAssociado;

    return (
      <Form name="dadosIniciais" noValidate={false}>
        <CheckObligationAssociado field="dadosIniciais_nomeCompleto">
          {(validacoes) => (
            <div className="col">
              <Field
                type="text"
                placeholder="Digite seu nome e sobrenome"
                required={validacoes.obrigatorio}
                label="Nome Completo"
                name="dadosIniciais_nomeCompleto"
                minlength={6}
                maxlength={100}
                value={form.dadosIniciais_nomeCompleto}
                onChange={this.changeDadosIniciaisForm}
                returnObject={this.createRefFields}
              />
            </div>
          )}
        </CheckObligationAssociado>

        <CheckObligationAssociado field="dadosIniciais_nomeSocial">
          {(validacoes) => (
            <div className="col">
              <Field
                type="text"
                placeholder="Digite seu nome social"
                required={validacoes.obrigatorio}
                label="Nome Social"
                name="dadosIniciais_nomeSocial"
                minlength={6}
                maxlength={100}
                value={form.dadosIniciais_nomeSocial}
                onChange={this.changeDadosIniciaisForm}
                returnObject={this.createRefFields}
              />
            </div>
          )}
        </CheckObligationAssociado>

        <CheckObligationAssociado field="dadosIniciais_dataNascimento">
          {(validacoes) => (
            <div className="col-50">
              <Field
                type="date"
                placeholder="12/06/1980"
                required={validacoes.obrigatorio}
                label="Data de Nascimento"
                name="dadosIniciais_dataNascimento"
                value={form.dadosIniciais_dataNascimento}
                onChange={this.changeDadosIniciaisForm}
                mask="99/99/9999"
                validateSync={() =>
                  Utils.isDate(
                    "<=",
                    form.dadosIniciais_dataNascimento,
                    new Date().setFullYear(new Date().getFullYear() - 16),
                    "Idade menor que 16 anos"
                  )
                }
                returnObject={this.createRefFields}
              />
            </div>
          )}
        </CheckObligationAssociado>

        <CheckObligationAssociado field="dadosIniciais_cpf">
          {(validacoes) => (
            <div className="col-50">
              <Field
                type="cpf"
                placeholder="999.999.999-99"
                required={validacoes.obrigatorio}
                label="CPF"
                name="dadosIniciais_cpf"
                value={form.dadosIniciais_cpf}
                mask="999.999.999-99"
                validateSync={Utils.isCPF}
                onChange={this.changeDadosIniciaisForm}
                returnObject={this.createRefFields}
              />
            </div>
          )}
        </CheckObligationAssociado>

        <div className="col-50">
          <CheckObligationAssociado field="dadosIniciais_ddiTelefoneCelular">
            {(validacoes) => (
              <div className="col-20 p-0">
                <FieldTelefone
                  type="ddi"
                  placeholder="+999"
                  required={validacoes.obrigatorio}
                  label="DDI"
                  name="dadosIniciais_ddiTelefoneCelular"
                  value={ddiFixoBrasil ? "+55" : form.dadosIniciais_ddiTelefoneCelular}
                  maxlength={5}
                  onChange={this.changeDadosIniciaisForm}
                  returnObject={this.createRefFields}
                  idDDIpais={dadosIniciais_idDDDpais}
                  onChangeDDI={(id) => this.changeDadosIniciais("dadosIniciais_idDDDpais", id)}
                  readOnly={ddiFixoBrasil}
                  selectToogle={!ddiFixoBrasil}
                  listPais={listPais.filter(x => x.DDI !== null)}
                />
              </div>
            )}
          </CheckObligationAssociado>

          <CheckObligationAssociado field="dadosIniciais_telefoneCelular">
            {(validacoes) => (
              <div className="col-70 p-0">
                <FieldTelefone
                  type="cel"
                  placeholder="(99)99999-9999"
                  required={validacoes.obrigatorio}
                  label="Telefone Celular (DDD + Número)"
                  name="dadosIniciais_telefoneCelular"
                  value={form.dadosIniciais_telefoneCelular}
                  maxlength={20 - form.dadosIniciais_ddiTelefoneCelular.replace("+", "").length}
                  onChange={this.changeDadosIniciaisForm}
                  returnObject={this.createRefFields}
                  ddiForMask={form.dadosIniciais_ddiTelefoneCelular}
                />
              </div>
            )}
          </CheckObligationAssociado>
        </div>           

        <CheckObligationAssociado field="dadosIniciais_email">
          {(validacoes) => (
            <div className="col-50">
              <Field
                type="email"
                placeholder="Digite seu e-mail"
                required={validacoes.obrigatorio}
                maxlength={100}
                label="E-mail"
                name="dadosIniciais_email"
                value={form.dadosIniciais_email}
                onChange={this.changeDadosIniciaisForm}
                returnObject={this.createRefFields}
              />
            </div>
          )}
        </CheckObligationAssociado>
      </Form>
    );
  }

  createRefFields = (self) => {
    this.formFields[self.props.name] = self;
  };
  
  handleValidations = async () => {
    const keys = Object.keys(this.formFields);
    if (keys.length === 0) return true;

    for (const key of keys)
      if (!await this.formFields[key].validate(this.formFields[key].input)) return false;

    return true;
  };
}

export default DadosIniciais;
